import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "config"
    }}>{`Config`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface TsAutoMockOptions {
    debug: boolean | 'file' | 'console';
    cacheBetweenTests: boolean;
    features: TsAutoMockFeaturesOption[];
}

export type TsAutoMockFeaturesOption = 'random';

`}</code></pre>
    <p>{`options:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`debug`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`it will NOT log to the console`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`it will log to the console`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`file`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`it will log to a file (tsAutoMock.log)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`console`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`alias for `}<inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cacheBetweenTests`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`it will reuse mocks between different tests`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`true`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`it create new mocks for each different tests`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`features`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`feature[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`it will enable a specific feature`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[]`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`files`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string or string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`it will include only the files matched`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`"*`}<em parentName="td">{`/`}</em>{`"`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <p>{`There are different ways to pass options to a transformer, every installation type has its own way, to know how to do it
find your configuration in the `}<a parentName="p" {...{
        "href": "./installation"
      }}>{`Installation page`}</a>{`.`}</p>
    <h2 {...{
      "id": "debug"
    }}>{`Debug`}</h2>
    <p>{`We currently support:`}</p>
    <ul>
      <li parentName="ul">{`Logs for `}<a parentName="li" {...{
          "href": "./types-not-supported"
        }}>{`not supported types`}</a></li>
    </ul>
    <p>{`It will log any not supported type automatically converted to null.
This is useful to report an issue or to investigate a potential bug.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "cachebetweentests"
    }}>{`CacheBetweenTests`}</h2>
    <p>{`One of the main functionality of ts auto mock is to generate mocks and cache them.`}</p>
    <p>{`Mocks are currently created in the test file making tests to depend to each other.`}</p>
    <p>{`Example:`}</p>
    <ul>
      <li parentName="ul">{`test1.test.ts has a createMock of Interface.`}</li>
      <li parentName="ul">{`test2.test.ts has a createMock of Interface.`}</li>
      <li parentName="ul">{`test1.test.ts will have the registration of Interface mock`}</li>
      <li parentName="ul">{`test2.test.ts will have a registration import.`}</li>
    </ul>
    <p>{`If test2 run in a different context than test1 it will not be able to access to the same mock.`}</p>
    <p>{`Set this property to false when your test run in different context.`}</p>
    <p>{`We are working on an `}<a parentName="p" {...{
        "href": "https://github.com/Typescript-TDD/ts-auto-mock/issues/101"
      }}>{`issue`}</a>{` to make sure tests do not depend to each other but they will still take advance of a cache system`}</p>
    <hr></hr>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <p>{`We currently support the following features`}</p>
    <h3 {...{
      "id": "random-random"
    }}>{`Random ('random')`}</h3>
    <p>{`When adding random to the feature list any string, boolean and number will be transformed to a random values`}</p>
    <h4 {...{
      "id": "string"
    }}>{`String`}</h4>
    <p>{`Example`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface WithString {
    prop: string;
}

createMock<WithString>() // { prop: 'propQsdeos'}
`}</code></pre>
    <p>{`The name of the property will be prepended following 6 random character`}</p>
    <h3 {...{
      "id": "number"
    }}>{`Number`}</h3>
    <p>{`Example`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface WithNumber {
    prop: number;
}

createMock<WithNumber>() // { prop: 5000.213123}
`}</code></pre>
    <p>{`A random number will be generated between -10000 and 10000`}</p>
    <h3 {...{
      "id": "boolean"
    }}>{`Boolean`}</h3>
    <p>{`Example`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface WithBoolean {
    prop: boolean;
}

createMock<WithBoolean>() // { prop: true|false}
`}</code></pre>
    <p>{`true|false will be random`}</p>
    <hr></hr>
    <h2 {...{
      "id": "files"
    }}>{`Files`}</h2>
    <p>{`To reduce the compilation time you can tell to the transformer the files that contain `}<inlineCode parentName="p">{`createMock`}</inlineCode>{`, `}<inlineCode parentName="p">{`createMockValue`}</inlineCode>{` and `}<inlineCode parentName="p">{`registerMock`}</inlineCode>{`,
all the other files are going to be ignored by the transformer.`}</p>
    <p>{`The value of this configuration is a `}<inlineCode parentName="p">{`glob`}</inlineCode>{` or array of `}<inlineCode parentName="p">{`glob`}</inlineCode>{`, the same type of matcher present in `}<inlineCode parentName="p">{`tsconfig`}</inlineCode>{` when
defining `}<inlineCode parentName="p">{`include`}</inlineCode>{`, `}<inlineCode parentName="p">{`exclude`}</inlineCode>{` and `}<inlineCode parentName="p">{`files`}</inlineCode>{` properties.`}</p>
    <p>{`Examples of usage:`}</p>
    <pre><code parentName="pre" {...{}}>{`files: "**/*.spec.ts"                       

| Structure                                    | Included?
| -------------------------------------------- | ---------
| root                                         |
| └── Projects                                 |
|     └── SuperProject                         |
|         ├── tests                            |
|         │   └── feature1                     |
|         │       ├── supporting.mock.ts       | No
|         │       ├── supportingInterface.ts   | No
|         │       ├── feature1.spec.ts         | Yes
|         │       └── feature1.spec.ts         | Yes
|         └── src                              |
|             └── feature1                     |
|                 ├── myClass.model.ts         | No
|                 ├── myClass.api.mock.ts      | No
|                 ├── model.interface.ts       | No
|                 └── feature1.component.ts    | No
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`files: ["**/tests/**/*.spec.ts", "**/tests/**/*.mock.ts"]

| Structure                                    | Included?
| -------------------------------------------- | ---------
| root                                         |
| └── Projects                                 |
|     └── SuperProject                         |
|         ├── tests                            |
|         │   └── feature1                     |
|         │       ├── supporting.mock.ts       | Yes
|         │       ├── supportingInterface.ts   | No
|         │       ├── feature1.spec.ts         | Yes
|         │       └── feature1.spec.ts         | Yes
|         └── src                              |
|             └── feature1                     |
|                 ├── myClass.model.ts         | No
|                 ├── myClass.api.mock.ts      | No
|                 ├── model.interface.ts       | No
|                 └── feature1.component.ts    | No
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      